module.exports = __webpack_public_path__ + "img/icone-tempo.ce3f590c.svg";